<template>
  <div class="bm-upload-file" >
    <div class="block" >
      <template>
        <div class="upload-profile-cardA" v-show="cardALod" >
          <van-loading type="spinner" />
        </div>
        <div v-show="!cardALod" class="teamIcon" style="display: flex; justify-content: center" >
          <van-uploader class="uploader" :after-read="onReadA" :disabled="player.auditProgress == 1">
            <img v-if="cardA" :src="cardA" alt="">
            <img v-if="!cardA" src="@/assets/images/id1.png" style="width: 215px; height: 130px;" >
          </van-uploader>
        </div>
      </template>
    </div>
    <div style="height: 10px; width: 100%" ></div>
    <div class="block" >
      <template>
        <div class="upload-profile-cardA" v-show="cardBLod" >
          <van-loading type="spinner" />
        </div>
        <div v-show="!cardBLod" class="teamIcon" style="display: flex; justify-content: center"  >
          <van-uploader class="uploader" :after-read="onReadB" :disabled="player.auditProgress == 1">
            <img v-if="cardB" :src="cardB" alt="">
            <img v-if="!cardB" src="@/assets/images/id2.png" style="width: 215px; height: 130px;" >
          </van-uploader>
        </div>
      </template>
    </div>
    <!-- 创建球员的时候才需要 直接根据playerId 判断是否 返回 或者直接提交修改 -->
    <div class="foot" v-if="!playerId" >
      <van-button type="primary" size="large" @click="goPlayerDetailPage">确认</van-button>
    </div>

    <div class="foot" v-if="playerId && type !== 'player' " >
      <van-button type="primary" size="large" @click="updateBMPlayer">确认</van-button>
    </div>

    <div class="foot" v-if="playerId && type === 'player'" >
      <van-button type="primary" size="large" @click="goPlayerDetailPage">确认</van-button>  <!-- 邀请球员 完善资料 -->
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { ImageFormat, varConfig } from '@/utils/'
import { getQiniuUploadToken } from '@/api/user'
import { updateBMPlayer, addSelftBMPlayer } from '@/api/team'
import { Button, Toast, Loading } from 'vant'

Vue.use(Button).use(Toast).use(Loading)

export default {
  name: 'UploadFile',
  data () {
    return {
      isReadA: false,
      isReadB: false,
      qiniuToken: '',
      player: {
        IDCardPhotoA: '',
        IDCardPhotoB: ''
      },
      type: null,
      cardALod: false,
      cardBLod: false
    }
  },
  computed: {
    cardA() {
      return ImageFormat.imageView(this.player.IDCardPhotoA, 0, 0)
    },
    cardB() {
      return ImageFormat.imageView(this.player.IDCardPhotoB, 0, 0)
    }
  },
  created() {
    this.query = this.$route.query
    this.type = this.query.type
    this.teamId = this.query.teamId
    this.matchId = this.query.matchId
    this.playerId = this.query.playerId
    this.player = {
      matchId: this.query.matchId,
      teamId: this.query.teamId,
      playerId: this.query.playerId,
      IDCardPhotoA: this.query.cardA,
      IDCardPhotoB: this.query.cardB,
      trueName: this.query.trueName,
      number: this.query.number,
      photo: this.query.photo,
      avatar: this.query.avatar,
      position: this.query.position,
      mobile: this.query.mobile,
      contactNumber: this.query.contactNumber,
      IDCardNumber: this.query.IDCardNumber,
      high: this.query.high,
      weight: this.query.weight,
      bmEmail: this.query.bmEmail,
      gender: this.query.gender,
      bmBirthday: this.query.bmBirthday,
      isProfessionalPlayer: this.query.isProfessionalPlayer,
      school: this.query.school,
      guardianName: this.query.guardianName,
      auditProgress: this.query.auditProgress || 0,
      auditRemark: this.query.auditRemark,
      qualificationFile: this.query.qualificationFile || '',
      insureFile: this.query.insureFile || ''
    }
    this.getQiniuToken()
  },
  methods: {
    onReadA(file) {
      this.cardALod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.player.IDCardPhotoA = res.hash
          this.cardALod = false
        }
      })
    },
    onReadB(file) {
      this.cardBLod = true
      this.uploadFile(file).then(res => {
        if (res) {
          this.player.IDCardPhotoB = res.hash
          this.cardBLod = false
        }
      })
    },
    uploadFile(file) {
      let formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      return new Promise((resolve, reject) => {
        axios.post(varConfig.qiniuUpload, formData, config).then(res => {
          const data = res.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getQiniuToken() {
      getQiniuUploadToken().then(response => {
        const data = response.data
        this.qiniuToken = data.token
      }).catch(err => {
        console.log(err)
        Toast('七牛Token获取失败')
      })
    },
    updateBMPlayer() {
      updateBMPlayer(this.player).then((response) => {
        const data = response.data
        if (data) {
          // Toast('更新成功')
          this.$router.go(-1)
        }
      })
    },
    goPlayerDetailPage() {
      let name = ''
      if (this.type === 'captain') {
        name = 'PlayerEdit'
      } else if (this.type === 'player') {
        name = 'NamePlayer'
      }
      this.$router.replace({ name: name,
        query: {
          cardA: this.player.IDCardPhotoA,
          cardB: this.player.IDCardPhotoB,
          IDCardPhotoA: this.player.IDCardPhotoA,
          IDCardPhotoB: this.player.IDCardPhotoB,
          trueName: this.player.trueName,
          number: this.player.number,
          photo: this.player.photo,
          avatar: this.player.avatar,
          position: this.player.position,
          mobile: this.player.mobile,
          contactNumber: this.query.contactNumber,
          IDCardNumber: this.player.IDCardNumber,
          IDCardNo: this.player.IDCardNumber,
          teamId: this.teamId,
          matchId: this.matchId,
          playerId: this.playerId,
          type: this.type,
          gender: this.player.gender,
          high: this.player.high,
          weight: this.player.weight,
          bmEmail: this.player.bmEmail,
          bmBirthday: this.player.bmBirthday,
          isProfessionalPlayer: this.player.isProfessionalPlayer,
          school: this.player.school,
          guardianName: this.player.guardianName,
          auditProgress: this.player.auditProgress,
          auditRemark: this.player.auditRemark,
          qualificationFile: this.player.qualificationFile,
          insureFile: this.player.insureFile
        }
      })
    },
    submitAction() {
      addSelftBMPlayer(this.player).then((res) => {
        const data = res.data
        if (data) {
          Toast('上传成功')
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.bm-upload-file
  background-color: #FAFAFA
  width 100%
  height: 100%
  position absolute
  .block
    position relative
    padding 15px
    min-height: 140px
    img
      width: 100%
    .upload-profile-cardA
      position absolute
      width 100%
      height 100%
      left 0
      top: 0
      background-color white
      .van-loading
        left: 50%
        top: 50%
        transform translate(-50%, -50%)
  .foot
    position fixed
    bottom 20px
    left 50%
    transform translate(-50%, 0)
    padding: 0 40px
    width: calc(100% - 80px)
  .foot
    .van-button
      border none
      font-size:16px;
      font-weight normal
      color:rgba(50,163,119,1);
      line-height:25px;
    .van-button--primary
      background-color #32A377
      font-size:16px;
      font-weight:400;
      color:rgba(255,255,255,1);
</style>



// WEBPACK FOOTER //
// src/pages/upload-file/index.vue